<template>
    <div>
        <ProgressBar :currentStepIndex="4" :allowNavigation="false" />

        <div class="contentblock">
            <section class="contentblock__content">
                <div class="pneu-offer__fieldgroup migrol-rt-content" style="font-size: 1.8rem" v-html="confirmationText"></div>
            </section>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import ProgressBar from './_common/ProgressBar';

    export default {
        computed: {
            ...mapState([
                'confirmationText'
            ])
        },
        mounted() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        components: {
            ProgressBar
        }
    };
</script>